import * as KycUsageAction from './action';
import { CORE_API, REPORT } from '../../config';
import { takeLatest, put, call } from 'redux-saga/effects';
import { HTTP_HEADERS, HTTP_HEADERS_FORMDATA, HTTP_HEADERS_RESPONSE_TYPE_ARRAYBUFFER, HTTP_RESPONSE_TYPE_ARRAYBUFFER } from '../../constants'
import request from "../../components/Utils/httpHelper";

export function* kycUsageStatsRequest(action) {
    let requestURL = `${CORE_API}/kyc/usage/download/${action.data.fromDate}/${action.data.toDate}`;
    try {
        const data = yield call(request, requestURL, { method: 'GET', headers: HTTP_HEADERS, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        yield put(KycUsageAction.kycUsageStatsResponse({ data: data, status: "SUCCESS" }))
    }
    catch (err) {
        yield put(KycUsageAction.kycUsageStatsResponse({ ...err.response, status: "FAILURE" }))
    }
}

export function* kycUsageStatsFileRequest() {
    yield takeLatest(KycUsageAction.KYC_USAGE_STATS_REQUEST, kycUsageStatsRequest);
}

export function* kycUsageMeteringReportRequest(action) {
    let requestURL = `${CORE_API}/kyc/bill/download/${action.data.fromDate}/${action.data.toDate}`;
    try {
        const data = yield call(request, requestURL, { method: 'GET', headers: HTTP_HEADERS, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        yield put(KycUsageAction.kycUsageMeteringResponse({ data: data, status: "SUCCESS" }))
    }
    catch (err) {
        yield put(KycUsageAction.kycUsageMeteringResponse({ ...err.response, status: "FAILURE" }))
    }
}

export function* kycUsageMeteringReportFileRequest() {
    yield takeLatest(KycUsageAction.KYC_USAGE_METERING_REQUEST, kycUsageMeteringReportRequest);
}


export function* downloadKycPricingRequestTemplateSaga(action) {
    
    let requestUrl = `${REPORT}/kyc/pricing/download`;
    try {
        const searchResult = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS_RESPONSE_TYPE_ARRAYBUFFER, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER  });
        yield put(KycUsageAction.downloadKycPricingRequestTemplateSuccess(searchResult.data));
    } catch (err) {
        yield put(KycUsageAction.downloadKycPricingRequestTemplateFailure(err))
    }
}
export function* getKycPricingRequestTemplate() {
    yield takeLatest(KycUsageAction.DOWNLOAD_KYC_PRICING_REQUEST_TEMPLATE, downloadKycPricingRequestTemplateSaga);
}

export function* submitKycPricingRequestSaga(action) {
    const formData = new FormData();
    formData.append('file', action.data.file);
    let requestUrl = `${REPORT}/kyc/pricing/upload`;
    try {
        const searchResult = yield call(request, requestUrl, { data: formData, method: 'POST', headers: HTTP_HEADERS_FORMDATA });
        yield put(KycUsageAction.submitKycPricingRequestSuccess(searchResult.data));
    } catch (err) {
        yield put(KycUsageAction.submitKycPricingRequestFailure(err))
    }
}
export function* submitKycPricingRequest() {
    yield takeLatest(KycUsageAction.SUBMIT_KYC_PRICING_REQUEST, submitKycPricingRequestSaga);
}

//KYC API USAGE

export function* kycApiUsageStatsRequest(action) {
    let requestURL = `${CORE_API}/kyc/api/usage/download/${action.data.fromDate}/${action.data.toDate}`;
    try {
        const data = yield call(request, requestURL, { method: 'GET', headers: HTTP_HEADERS, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        yield put(KycUsageAction.kycApiUsageStatsResponse({ data: data, status: "SUCCESS" }))
    }
    catch (err) {
        yield put(KycUsageAction.kycApiUsageStatsResponse({ ...err.response, status: "FAILURE" }))
    }
}

export function* kycApiUsageStatsFileRequest() {
    yield takeLatest(KycUsageAction.KYC_API_USAGE_STATS_REQUEST, kycApiUsageStatsRequest);
}